import React from 'react'
import styled from 'styled-components'
import { Text } from 'rebass'
import { useLocation } from 'react-router-dom'

import ImgBox from '../../components/Gamification/ImgBox'
import ExchangeNft from '../../components/Gamification/ExchangeNft'
import { RowColumn } from '../../components/Row'

import { NFTTYPE } from '../../constants/bakery/nft'

const SoccerMain = styled.div`
  width: 890px;
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    width: 100%;
  `};
`
const Main = styled.div`
  width: 100%;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`
const activeClassName = 'ACTIVENAV'

const AutoRowColumn = styled(RowColumn)`
  height: 543px;
`

const Info = styled.div`
  color: ${({ theme }) => theme.bsText7};
  width: 432px;
  height: auto;
  flex: 1;
  margin-top: 25px;
  overflow-y: scroll;
  padding: 16px 30px;
  border-radius: 20px;
  background: ${({ theme }) => theme.bsBg2};
  ${({ theme }) => theme.mediaWidth.upToMedium`
    width: 90%;
    height: auto;
    margin: 0 auto;
    margin-bottom: 20px;
  `};
`

const TextLink = styled.a`
  margin-top: 20px;
  font-size: 14px;
  color: inherit;
`


export default function Matrix () {
  const location = useLocation()
  return (
    <SoccerMain>
      <Main>
        <ImgBox imgLink={'/images/nft/bmm.svg'}/>
        <AutoRowColumn>
          <ExchangeNft type={NFTTYPE.BAKEMUSKMIXER} />
          <Info className={location.pathname.indexOf('gamification/car') > -1 ? activeClassName : ''}>
            <Text fontSize={18} fontFamily={'Baloo Da'} fontWeight={700}>Matrix+ mystery box and Bake community card mixer</Text>
            <Text fontSize={14} marginTop={20}>The total supply is 10,000 $BMM NFTs. All $BMM in this mixer can farm $BAKE.</Text>
            <Text fontSize={14} marginTop={20}>Each is programmatically generated with a unique serial number from 10010–19999. Each BMM is unique and rare.</Text>
            <Text fontSize={14} marginTop={20}>What’s in the mixer:</Text>
            <Text fontSize={14} marginTop={20}>1. 10 MPB Avatar to claim MPB box. They can claim MPB 2000– MPB 2009.</Text>
            <Text fontSize={14} marginTop={20}>2. 100 Bake Community Cards wrapped with one parcel free Land in Bake State, the United States of Mars. (19000–19099)</Text>
            <Text fontSize={14} marginTop={20}>3. 1000 spacial cards that can claim 1000 pairs of Bake-RACA socks. (10400–11399)</Text>
            <Text fontSize={14} marginTop={20}>4. 8890 ordinary Bake Community Cards. (11400-18999 and 19100-19999)</Text>
            <br/>
            <Text fontSize={18} fontFamily={'Baloo Da'} fontWeight={700}>What’s the price of the upcoming 10,000 BMM NFTs?</Text>
            <Text fontSize={14} marginTop={20}>390 will be giveaway on RACA Twitter.</Text>
            <Text fontSize={14} marginTop={20}>5610 will be up for sale for BNB. Each is 0.08 $BNB</Text>
            <Text fontSize={14} marginTop={20}>4000 BMM will be as the prizes for the $bake lottery. One lottery requires 0.08 $bake and you have 4% chance to get one BMM. All the bake from the lottery will be burned.</Text>
            <br/>
            <Text fontSize={18} fontFamily={'Baloo Da'} fontWeight={700}>More detail:</Text>
            <TextLink href={'https://radiocaca.medium.com/matrix-mystery-box-and-bake-community-card- mixer-7e0b52a2abf6'} target={'_blank'}>https://radiocaca.medium.com/matrix-mystery-box-and-bake-community-card- mixer-7e0b52a2abf6</TextLink>
          </Info>
        </AutoRowColumn>
      </Main>
    </SoccerMain>
  )
}